import axios, { AxiosInstance } from 'axios';
import { configureAxios } from 'common/services/axios-base-configuration.service';

const axiosInstance: AxiosInstance = configureAxios(axios);

export default axiosInstance;
